import { render } from "./PasswordRecoverPage.vue?vue&type=template&id=60ad7365&ts=true"
import script from "./PasswordRecoverPage.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoverPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/PasswordRecoverPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60ad7365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60ad7365', __exports__)) {
    api.reload('60ad7365', __exports__)
  }
  
  module.hot.accept("./PasswordRecoverPage.vue?vue&type=template&id=60ad7365&ts=true", () => {
    api.rerender('60ad7365', render)
  })

}


export default __exports__